var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container order-list" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _vm.Filter == false
        ? _c("div", { staticClass: "content1" }, [
            _c("div", { staticClass: "content-title" }, [
              _c("div", { staticClass: "padding" }, [_vm._v("客服订单")]),
              _c(
                "div",
                { staticClass: "padding-right", on: { click: _vm.showFilter } },
                [
                  _vm._v("高级搜索"),
                  _c("img", {
                    attrs: {
                      src: require("../../../src/assets/icon/icon_sousuo.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.Filter == true
        ? _c("div", { staticClass: "content1" }, [
            _c("div", { staticClass: "content-title" }, [
              _c("div", { staticClass: "padding" }, [_vm._v("客服订单")]),
              _c(
                "div",
                { staticClass: "padding-right", on: { click: _vm.showFilter } },
                [
                  _vm._v("收起全部"),
                  _c("img", {
                    attrs: {
                      src: require("../../../src/assets/icon/icon_shouqi.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "search-box" },
              [
                _c(
                  "el-form",
                  {
                    ref: "searchForm",
                    staticClass: "search-form",
                    attrs: {
                      inline: true,
                      id: "searchForm",
                      model: _vm.searchForm,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "订单编号", prop: "orderNo" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            placeholder: "请输入订单编号",
                            oninput: "value=value.replace(/[^0-9.]/g,'')",
                            filterable: "",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                          model: {
                            value: _vm.searchForm.orderNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.searchForm,
                                "orderNo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "searchForm.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "关联订单号", prop: "platformOrderNo" },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            oninput: "value=value.replace(/[\\W]/g,'')",
                            placeholder: "请输入关联订单号",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                          model: {
                            value: _vm.searchForm.platformOrderNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.searchForm,
                                "platformOrderNo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "searchForm.platformOrderNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户信息", prop: "postUserInfo" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            placeholder: "请输入客户信息",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                          model: {
                            value: _vm.searchForm.postUserInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "postUserInfo", $$v)
                            },
                            expression: "searchForm.postUserInfo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "公司部门", prop: "orgCode" } },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.orgCodeList,
                            placeholder: "请选择公司部门",
                            size: "small",
                            "show-all-levels": false,
                            props: {
                              label: "orgName",
                              value: "orgCode",
                              emitPath: false,
                              multiple: true,
                              checkStrictly: true,
                            },
                            clearable: "",
                          },
                          on: { change: _vm.onChangeCategory },
                          model: {
                            value: _vm.searchForm.orgCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "orgCode", $$v)
                            },
                            expression: "searchForm.orgCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "跟进客服", prop: "applierId" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择跟进客服",
                              size: "small",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.applierId,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "applierId", $$v)
                              },
                              expression: "searchForm.applierId",
                            },
                          },
                          _vm._l(_vm.salesAuthority, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.reallyName, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品名称", prop: "goodsName" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            placeholder: "请输入商品名称",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                          model: {
                            value: _vm.searchForm.goodsName,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "goodsName", $$v)
                            },
                            expression: "searchForm.goodsName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "订单类型", prop: "orderType" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择订单类型",
                              size: "small",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.orderType,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "orderType", $$v)
                              },
                              expression: "searchForm.orderType",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.order_main_type,
                            function (item) {
                              return _c("el-option", {
                                key: item.dictId,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "来源平台", prop: "platformId" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择平台",
                              size: "small",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.platformId,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "platformId", $$v)
                              },
                              expression: "searchForm.platformId",
                            },
                          },
                          _vm._l(_vm.platformDataList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提成类型", prop: "bonusType" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择提成类型",
                              size: "small",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.bonusType,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "bonusType", $$v)
                              },
                              expression: "searchForm.bonusType",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.order_bonus_type,
                            function (item) {
                              return _c("el-option", {
                                key: item.dictId,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showBonusStatus,
                            expression: "showBonusStatus",
                          },
                        ],
                        attrs: {
                          label: "申诉审核状态",
                          prop: "bonusReviewStatus",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择申诉审核状态",
                              size: "small",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.bonusReviewStatus,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchForm,
                                  "bonusReviewStatus",
                                  $$v
                                )
                              },
                              expression: "searchForm.bonusReviewStatus",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.order_bonus_review_status,
                            function (item) {
                              return _c("el-option", {
                                key: item.dictId,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提交审核时间", prop: "createdTime" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          on: { change: _vm.onChangeTime },
                          model: {
                            value: _vm.searchForm.createdTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "createdTime", $$v)
                            },
                            expression: "searchForm.createdTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.currentTab == 14
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: "确认修改", prop: "bonusKnowFlag" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择确认修改状态",
                                  size: "small",
                                  filterable: "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.bonusKnowFlag,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "bonusKnowFlag",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.bonusKnowFlag",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: "0",
                                  attrs: { label: "未确认", value: 0 },
                                }),
                                _c("el-option", {
                                  key: "1",
                                  attrs: { label: "已确认", value: 1 },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              plain: "",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.fetchData("search")
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.fetchData("search")
                              },
                            },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.fetchData("reset")
                              },
                            },
                          },
                          [_vm._v("重置 ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("数据列表")]),
          _c("div", { staticClass: "btn-list tabclass" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.all
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(_vm.currentTabStatus.all)
                      },
                    },
                  },
                  [_vm._v("全部 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.beforeSubmit
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.beforeSubmit
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "待提交(" +
                        _vm._s(_vm.statusCount.waitingSubmitCount) +
                        ") "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.underReview
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.underReview
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "审核订单(" + _vm._s(_vm.statusCount.processCount) + ") "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.shipments
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.shipments
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "发货前(" + _vm._s(_vm.statusCount.prePostCount) + ") "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.signFor
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.signFor
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "待签收(" +
                        _vm._s(_vm.statusCount.preReceivedCount) +
                        ") "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.accomplish
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.accomplish
                        )
                      },
                    },
                  },
                  [_vm._v("已完成 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.close
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.close
                        )
                      },
                    },
                  },
                  [_vm._v("已关闭 ")]
                ),
                _c(
                  "el-badge",
                  {
                    attrs: {
                      "is-dot":
                        !!_vm.unreadStatus.appealingUnread &&
                        _vm.statusCount.appealAuditingCount > 0,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "tabBtn",
                        attrs: {
                          plain: "",
                          type: "info",
                          disabled: _vm.loading,
                          type:
                            _vm.currentTab == _vm.currentTabStatus.auditIng
                              ? "primary"
                              : "info",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onChangeCurrentTab(
                              _vm.currentTabStatus.auditIng
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          " 申诉审核中(" +
                            _vm._s(_vm.statusCount.appealAuditingCount || 0) +
                            ") "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-badge",
                  {
                    attrs: {
                      "is-dot":
                        !!_vm.unreadStatus.appealRejectedUnread &&
                        _vm.statusCount.appealRejectedCount > 0,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "tabBtn",
                        attrs: {
                          plain: "",
                          type: "info",
                          disabled: _vm.loading,
                          type:
                            _vm.currentTab == _vm.currentTabStatus.auditReject
                              ? "primary"
                              : "info",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onChangeCurrentTab(
                              _vm.currentTabStatus.auditReject
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "申诉驳回(" +
                            _vm._s(_vm.statusCount.appealRejectedCount || 0) +
                            ")"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-badge",
                  {
                    attrs: {
                      "is-dot":
                        !!_vm.unreadStatus.appealApprovedUnread &&
                        _vm.statusCount.appealApprovedCount > 0,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "tabBtn",
                        attrs: {
                          plain: "",
                          type: "info",
                          disabled: _vm.loading,
                          type:
                            _vm.currentTab == _vm.currentTabStatus.bonusSuccess
                              ? "primary"
                              : "info",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onChangeCurrentTab(
                              _vm.currentTabStatus.bonusSuccess
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "申诉通过(" +
                            _vm._s(_vm.statusCount.appealApprovedCount || 0) +
                            ")"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-badge",
                  {
                    attrs: {
                      "is-dot":
                        !!_vm.unreadStatus.commissionChangedUnread &&
                        _vm.statusCount.bonusModifiedCount > 0,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "tabBtn",
                        attrs: {
                          plain: "",
                          type: "info",
                          disabled: _vm.loading,
                          type:
                            _vm.currentTab == _vm.currentTabStatus.bonusEdit
                              ? "primary"
                              : "info",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onChangeCurrentTab(
                              _vm.currentTabStatus.bonusEdit
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "被改提成(" +
                            _vm._s(_vm.statusCount.bonusModifiedCount || 0) +
                            ")"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.parArray.indexOf("applier_outWeb_export") != -1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "yellowBtn",
                        attrs: { type: "warning" },
                        on: {
                          click: function ($event) {
                            return _vm.showDialog(
                              "站外订单物流透视",
                              "400px",
                              "transparent"
                            )
                          },
                        },
                      },
                      [_vm._v("站外订单物流透视 ")]
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("order_daochu") != -1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "blueBtn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onApplierExport },
                      },
                      [_vm._v("导出 ")]
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("tianlanExportCode") != -1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "blueBtn serviceDerive",
                        attrs: { type: "primary", loading: _vm.loadingState },
                        on: { click: _vm.serviceDerive },
                      },
                      [_vm._v("健驰订单数据导出 ")]
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("kefuExportCode") != -1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "blueBtn promotionDerive",
                        attrs: {
                          type: "primary",
                          loading: _vm.loadingStateTwo,
                        },
                        on: { click: _vm.promotionDerive },
                      },
                      [_vm._v("业务订单数据导出 ")]
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("serviceDeriveStatistics") != -1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "blueBtn serviceDeriveTwo",
                        attrs: {
                          loading: _vm.loadingStateThree,
                          type: "primary",
                        },
                        on: { click: _vm.serviceDeriveStatistics },
                      },
                      [_vm._v("健驰统计数据导出 ")]
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("promotionDeriveStatistics") != -1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "blueBtn promotionDeriveTwo",
                        attrs: {
                          loading: _vm.loadingStateFour,
                          type: "primary",
                        },
                        on: { click: _vm.promotionDeriveStatistics },
                      },
                      [_vm._v("业务统计数据导出 ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("orders-list-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              typeStr: _vm.columns.type,
              config: _vm.columns.config,
              sortObj: _vm.columns.sortObj,
              parArrayArr: _vm.parArray,
            },
            on: {
              onTableShowDialogCom: _vm.resTableShowDialog,
              outTableCancelOrderMsg: _vm.onCancelOrderMsg,
              tableSelectionChange: _vm.handleSelectionChange,
            },
          }),
          _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page.pageNo,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-bonus",
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "faqishensu"
            ? [
                _c("SetShensu", {
                  ref: "setShensu",
                  attrs: {
                    orderObj: _vm.dialog.row,
                    visible: _vm.dialog.visible,
                  },
                  on: {
                    dialogVisible: _vm.closeDialog,
                    submitState: _vm.modifyState,
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "chakanshensu"
            ? [
                _c("checkShensu", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    visible: _vm.dialog.visible,
                  },
                  on: {
                    dialogVisible: _vm.closeDialog,
                    submitState: _vm.modifyState,
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "shensujilu"
            ? [
                _c("StepProgressShesu", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    visible: _vm.dialog.visible,
                  },
                  on: { dialogVisible: _vm.closeDialog },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "shensuxiugai"
            ? [
                _c("EditShensu", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    visible: _vm.dialog.visible,
                  },
                  on: {
                    dialogVisible: _vm.closeDialog,
                    submitState: _vm.modifyState,
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "confirmModify"
            ? [
                _c("ConfirmModify", {
                  attrs: { orderObj: _vm.dialog.row },
                  on: {
                    dialogVisible: _vm.closeDialog,
                    submitState: _vm.modifyState,
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "modifyOrderNoOne"
            ? [
                _c("modify-order-no", {
                  ref: "modifyOrderNo",
                  attrs: {
                    orderObj: _vm.dialog.row,
                    type: _vm.dialog.type,
                    source: "service",
                  },
                  on: { submitState: _vm.modifyState },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "logisticsMessageOne"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    type: "logisticsMessageOne",
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "shenheStep"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    processFunc: _vm.dictionaries.process_func,
                    type: "shenheStep",
                  },
                  on: { dialogVisible: _vm.closeDialog },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "transparent"
            ? [
                _c(
                  "div",
                  [
                    _c("upload-file", {
                      ref: "transparent",
                      on: { dialogVisible: _vm.closeDialog },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "closeOrder"
            ? [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.setCloseOrder,
                      callback: function ($$v) {
                        _vm.setCloseOrder = $$v
                      },
                      expression: "setCloseOrder",
                    },
                  },
                  _vm._l(
                    _vm.dictionaries.order_main_close_reason,
                    function (item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: index,
                          staticClass: "setPay_payment",
                          attrs: { label: item.dictId },
                        },
                        [_vm._v(_vm._s(item.dictName) + " ")]
                      )
                    }
                  ),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright dialogBtnright_right",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerCloseOrderSubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "modifyOrderNoOne" ||
          _vm.dialog.type === "transparent"
            ? _c(
                "div",
                { staticClass: "dialog-btn" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "setPay_payment_btn_quxiao",
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.closeDialog()
                          _vm.$refs.transparent.$refs.uploadFileXls.clearFiles()
                        },
                      },
                    },
                    [_vm._v("取消 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "setPay_payment_btn_queren",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.actionDialog()
                          _vm.$refs.transparent.$refs.uploadFileXls.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确认 ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }